import Grid from '@mui/material/Grid';
import MeetingText from './MeetingText';


export default function SectionMeeting() {

    
    return (

        <Grid container sx={{width: '100vw', p:12, display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: 'tertiary.light'}}>
  
            <Grid item xs={2} sx={{mr:8}}> <MeetingText /> </Grid>
            
            <Grid item xs={2}> 
                    <Grid container direction="column" sx={{ mr:8,}}>
                        <Grid item sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', }}>  </Grid>
                        <Grid item sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>   </Grid>
                    </Grid>
            </Grid>
        
        </Grid>

    )
}